<template>
	<div class="card card-car">
		<div class="card-body">
			<h5 class="card-title">Eigenschaften</h5>
			<table class="table-features table mb-0">
				<tr v-if="car.ad.cubicCapacity">
					<td class="label">Hubraum</td>
					<td>{{ car.ad.cubicCapacity }} ccm</td>
				</tr>
				<tr>
					<td class="label">Türen</td>
					<td>{{ car.displayAd.doors }}</td>
				</tr>
				<tr>
					<td class="label">Sitze</td>
					<td>{{ car.displayAd.seats }}</td>
				</tr>
				<tr>
					<td class="label">Polsterung</td>
					<td>
						{{ car.displayAd.interiorType }}
						<span
							v-if="car.displayAd.interiorColor"
							class="text-muted font-14 font-italic"
						>
							{{ car.displayAd.interiorColor }}</span
						>
						<span v-if="car.ad.leatherSteeringWheel"
							><br />
							Lederlenkrad</span
						>
					</td>
				</tr>
				<tr>
					<td class="label">Außenfarbe</td>
					<td>
						{{ car.displayAd.exteriorColor
						}}<span
							class="text-muted font-14 font-italic"
							v-if="car.ad.metallic"
						>
							Metallic</span
						>
					</td>
				</tr>
				<tr v-if="car.displayAd.manufacturerColorName !== 'undefined'">
					<td class="label">Farbname</td>
					<td>{{ car.displayAd.manufacturerColorName }}</td>
				</tr>
			</table>
		</div>
	</div>
</template>

<script>
export default {
	name: 'DetailsCardFeaturesExtra',
	props: {
		refData: Object,
		car: Object,
	},
}
</script>

<style scoped></style>
